import { useQuery } from "@tanstack/react-query";
import type { AuthSession } from "../auth/keycloak.js";
import { apiClient } from "./client.js";

/**
 * One query, shared. Every consumer — the header chip, the account panel, and the manuals view's View/Edit gate
 * (ADR-002 Phase A) — reads the SAME cache entry, so they can never disagree about who is signed in, and it is one
 * request rather than N. Keyed by tenant + subject so switching either cannot serve a cached profile belonging to
 * someone else. Returns `MeSchema` (`.data.id` = the caller's LOCAL numeric user id).
 */
export function useMe(session: AuthSession | null) {
  return useQuery({
    queryKey: ["me", session?.realm, session?.sub],
    enabled: session !== null,
    queryFn: async () => {
      const res = await apiClient.getMe();
      if (res.status !== 200) throw new Error(`GET /me returned ${res.status}`);
      return res.body;
    },
  });
}
